module.exports = __webpack_public_path__ + "img/spartan-build-design-01-xlarge.35d310fc.jpg";